import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAuthHeader } from '../../utils/tools';

export const companySearch = createAsyncThunk(
    'companySearch/companySearch',
    async(searchTerm, {dispatch}) => {
        try {
            if (searchTerm.length < 3) return;

            const request = await axios.post(
                `/api/firms/search`, 
                { companyName: searchTerm }, 
                getAuthHeader() // Použijeme priamo
            );
            
            return request.data;

        } catch(error) {
            throw error;
        }
    }
);

export const companyDetail = createAsyncThunk(
    'companySearch/companyDetail',
    async(company, {dispatch}) => {
        try {

            const request = await axios.post(
                `/api/firms/detail/${company.identificationNumber}`,
                { company },
                getAuthHeader()
            );

            return request.data;
        } catch(error) {
            throw error;
        }
    }
)